import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { API_BASE_URL } from '../config';
import '../assets/css/ContactForm.css';
import contactImage from '../assets/images/banner/contact.png';
import axios from 'axios';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [emailStatus, setEmailStatus] = useState(null); // Track email sending status

  // Test email function for debugging
  const testEmailConnection = async () => {
    console.log('🧪 Testing email connection...');
    setEmailStatus('testing');
    
    try {
      const testData = new FormData();
      testData.append('fullName', 'Test User');
      testData.append('email', 'test@designcraft.ae');
      testData.append('phone', '971501234567');
      testData.append('subject', 'Email Test');
      testData.append('message', 'This is a test message to verify email functionality.');

      const response = await axios({
        method: 'post',
        url: `${API_BASE_URL}submit-contact.php`,
        data: testData,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 10000
      });

      if (response.data.success) {
        setEmailStatus('working');
        console.log('✅ Email system is working correctly!');
      } else {
        setEmailStatus('failed');
        console.log('❌ Email test failed:', response.data.message);
      }
    } catch (error) {
      setEmailStatus('failed');
      console.error('❌ Email test error:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData(prevState => ({
      ...prevState,
      phone: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    // Validate form data before sending
    if (!formData.fullName || !formData.email || !formData.phone || !formData.subject || !formData.message) {
      setStatus({
        type: 'error',
        message: 'Please fill in all required fields.'
      });
      setLoading(false);
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setStatus({
        type: 'error',
        message: 'Please enter a valid email address.'
      });
      setLoading(false);
      return;
    }

    console.log('📧 Sending contact form data:', {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      messageLength: formData.message.length
    });

    const formDataToSend = new FormData();
    Object.keys(formData).forEach(key => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      console.log('🚀 Making API request to:', `${API_BASE_URL}submit-contact.php`);
      
      const response = await axios({
        method: 'post',
        url: `${API_BASE_URL}submit-contact.php`,
        data: formDataToSend,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 10000 // 10 second timeout
      });
      
      console.log('✅ API Response:', response.data);
      
      if (response.data.success) {
        setStatus({
          type: 'success',
          message: 'Thank you for your message! We will get back to you soon. A confirmation email has been sent to your email address.'
        });
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
        console.log('✅ Email sent successfully!');
      } else {
        throw new Error(response.data.message || 'Something went wrong');
      }
    } catch (error) {
      console.error('❌ Contact form submission error:', error);
      
      let errorMessage = 'Failed to submit form. Please try again later.';
      
      if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND') {
        errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
      } else if (error.code === 'ECONNABORTED') {
        errorMessage = 'Request timed out. Please try again.';
      } else if (error.response?.status === 400) {
        errorMessage = error.response.data.message || 'Invalid form data. Please check your inputs.';
      } else if (error.response?.status === 500) {
        errorMessage = 'Server error. Please try again later or contact support.';
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setStatus({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-image">
        <img src={contactImage} alt="Modern office interior with wooden finishes" />
      </div>
      
      <div className="contact-form-container">
        <h2 className="contact-title">Contact Us</h2>
        <p className="contact-subtitle">
          We're here to address your inquiries, feedback, and order products promptly and effectively
        </p>
        
        {/* Email Status Indicator */}
        {/* <div className="email-status" style={{
          padding: '10px',
          marginBottom: '15px',
          borderRadius: '5px',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: emailStatus === 'working' ? '#d4edda' : 
                         emailStatus === 'failed' ? '#f8d7da' : 
                         emailStatus === 'testing' ? '#fff3cd' : '#e9ecef',
          color: emailStatus === 'working' ? '#155724' : 
                 emailStatus === 'failed' ? '#721c24' : 
                 emailStatus === 'testing' ? '#856404' : '#6c757d',
          border: `1px solid ${emailStatus === 'working' ? '#c3e6cb' : 
                              emailStatus === 'failed' ? '#f5c6cb' : 
                              emailStatus === 'testing' ? '#ffeaa7' : '#dee2e6'}`
        }}>
          <span>
            Email Status: {
              emailStatus === 'working' ? '✅ Working' :
              emailStatus === 'failed' ? '❌ Failed' :
              emailStatus === 'testing' ? '🔄 Testing...' :
              '❓ Not Tested'
            }
          </span>
          <button 
            type="button"
            onClick={testEmailConnection}
            disabled={emailStatus === 'testing'}
            style={{
              padding: '5px 10px',
              fontSize: '12px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer',
              opacity: emailStatus === 'testing' ? 0.6 : 1
            }}
          >
            {emailStatus === 'testing' ? 'Testing...' : 'Test Email'}
          </button>
        </div> */}
        
        {status.message && (
          <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-danger'}`}>
            {status.message}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter Your Full Name"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter Your Email"
                required
              />
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Phone No</label>
              <PhoneInput
                country={'ae'}
                value={formData.phone}
                onChange={handlePhoneChange}
                inputClass="form-input"
                containerClass="phone-input-container"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Subject</label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="form-select"
                required
              >
                <option value="" disabled>Select Option</option>
                <option value="Product Inquiry">Product Inquiry</option>
                <option value="Place an Order">Place an Order</option>
                <option value="Customer Support">Customer Support</option>
                <option value="General Feedback">General Feedback</option>
              </select>
            </div>
          </div>
          
          <div className="form-group">
            <label className="form-label">Your Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
              placeholder="Your Message"
              required
            ></textarea>
          </div>
          
          <button 
            type="submit" 
            className="contact-submit-btn"
            disabled={loading}
          >
            {loading ? 'Loading.....' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm; 